module.exports = __webpack_public_path__ + "static/media/sent_img.a15be869.png";